export enum DocumentParentTypes {
	Route = "Route",
	Shipment = "Shipment",
	RouteShipment = "RouteShipment",
	RoutePartCMR = "RoutePartCMR",
	ManagementModelRequirementResponseDocument = 'ManagementModelRequirementResponseDocument',
	Phase = "Phase",
	PhaseShipment = "PhaseShipment",
	None = "None"
}